// extracted by mini-css-extract-plugin
module.exports = {"reportListTitle":"styles_reportListTitle__28pLa"};